const isHasScenariosError = (item) => {
  if (typeof item === "string") {
    return item === "Evaluation template has scenarios";
  }

  if (typeof item === "object" && item) {
    return item.error === "has_scenarios";
  }

  return false;
};

export const getCriteriaDeleteErrorMessage = (payload, t) => {
  const baseErrors = payload?.errors?.base;

  if (!baseErrors) {
    return payload?.message || t("popup.delete_data.error_generic");
  }

  const items = Array.isArray(baseErrors) ? baseErrors : [baseErrors];

  if (items.some(isHasScenariosError)) {
    return t("popup.delete_data.error_criteria_has_scenarios");
  }

  const fallback = items
    .map((item) => {
      if (typeof item === "string") {
        return item;
      }

      return item?.error || "";
    })
    .filter(Boolean)
    .join(", ");

  return fallback || t("popup.delete_data.error_generic");
};
